import React, { useState , useEffect } from 'react';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import Footer from '../components/Footer';
import { Link, Navigate, useNavigate , useParams } from 'react-router-dom';
import { doc , db , setDoc , signOut , auth , getDoc } from '../firebase';


const EditProfile = () => {

    let navigate = useNavigate();
    let { userId } = useParams();
    const [userObject , setUserObject ] = useState({});

    const user = JSON.parse(localStorage.getItem("tourst_compass_user"));

    useEffect(() => {

        window.scrollTo(0,0);
        
        const getProductsFromFirestore = async () => {
          const docRef = doc(db, "users", userId ? userId : '' );
    const docSnap = await getDoc(docRef);
    
    if (docSnap.exists()) {
     
      setUserObject(docSnap.data());
      setUserName(userObject.name);
      setUserAge(userObject.age);
      setUserCountry(userObject.country);
      setUserEmail(userObject.email);

    } else {
    
      setUserObject(null)
    }
    
    
        }
        getProductsFromFirestore();
    
      } , []);


    const [userName , setUserName] = useState( userObject ? userObject.name : '' );
    const [userAge , setUserAge] = useState( userObject ? userObject.age : '' );
    const [userCountry , setUserCountry] = useState( userObject ? userObject.country : '' );
    const [userEmail , setUserEmail] = useState( userObject ? userObject.email : '' );
 

    const [loading , setLoading] = useState(false);
    const [error , setError] = useState('');
    const [success , setSuccess ] = useState(false);

   

      

    const logoutUser = () => {

        localStorage.removeItem("tourst_compass_user");
    
        signOut(auth).then(() => {
    
          navigate('/');
          
          }).catch((error) => {
           
          });
    
          window.location.reload();
    }


    const editProfile = (e) => {
        e.preventDefault();

        setLoading(true);

        if (userName === ''  ) {
            setError('يرجى ادخال اسم المستخدم')
    }
  
    if (userAge === ''  ) {
            setError('يرجى ادخال عمر المستخدم');
    }
  
    if (userCountry === ''  ) {
        setError('يرجى ادخال دولة المستخدم');
    }
  
    if (userEmail === ''  ) {
        setError('يرجى ادخال ايميل المستخدم');
    }

    setTimeout(() => {
        setLoading(false);
        setError('');
      } , 2500);

    if (userName !== '' && userAge !== '' && userCountry && userEmail  ) {

        const docRef = doc(db, "users", user.id);
    
        const data = {
    
          name : userName,
          email: userEmail,
          country: userCountry,
          age: userAge,

        };

        setDoc(docRef, data);

        setSuccess(true);
        setLoading(false);

        setTimeout(() => {
          setSuccess(false);
          navigate('/');
        } , 2500);

    }


    }


  return (
     <div className="main_homepage" >

{ !user ? <Navigate to="/" replace /> : ''  }
{ !userId ? <Navigate to="/" replace /> : ''  }

    <NavbarHome />

  

    <div className="section most_features_section container-sm">

    <div className="d-flex-c f-sp">

    <div className="d-flex-c">

<div className="info_box"></div>
<h1 className="main_headline">  تعديل الملف الشخصي </h1>
</div>

<Link to="/" >
    <img src="/images/icons/left-arrow-black.png" className='icon_smaller' alt="" />
    </Link>

    </div>


    <div className="single_profile_section mt-5">

    <form onSubmit={editProfile} >


    {error && (
                            <>
                            <h1 className="mb-1 error_headline"> {error} </h1>
                            </>
                        )}

                {success && (
                    <>
                        <div className="popup_success">
                            <img src="/images/icons/check.png" alt="" />
                        </div>
                    </>
                )}

    <div className="d-flex-c f-sv inputs_div_coll mt-3">

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form">الاسم الكامل</label>
<input value={userName} onChange={(e) => setUserName(e.target.value) }  type="text" className="login_input_form" />
</div>

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form">  الايميل </label>
<input value={userEmail} onChange={(e) => setUserEmail(e.target.value) }   type="email" className="login_input_form" />
</div>


</div>

    <div className="d-flex-c f-sv inputs_div_coll mt-3">

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form"> العمر </label>
<input value={userAge} onChange={(e) => setUserAge(e.target.value) }   type="text" className="login_input_form" />
</div>

<div className="input_form_div mx-3 w-100">

<label htmlFor="" className="login_label_form">  المدينة </label>
<input value={userCountry} onChange={(e) => setUserCountry(e.target.value) }   type="text" className="login_input_form" />
</div>


</div>

                    {loading ? (
                        <>
                                <img src="/images/icons/loading-spinner.gif" className='loading_spinner' alt="" />
                            </>
                    ) : (
                        <>
                        <button type='submit' className="btn_shopping p-2 w-100 mt-5"  >    تغيير المعلومات </button>

                        <button className="btn_category  bg_red w-100 mt-1" onClick={() => logoutUser() }  >    تسجيل الخروج </button>
                        </>
                     
                    )}


     </form>




    </div>

    </div>


    <Footer />
    </div>
  )
}

export default EditProfile